import gql from "graphql-tag";
import AssetDiscussionCommentFields from "../../fragments/AssetDiscussionCommentFields";
import AssetDiscussionCommentReplyFields from "../../fragments/AssetDiscussionCommentReplyFields";

export default gql`
  query AssetDiscussionCommentByShortId($commentShortId: ID!) {
    assetDiscussionCommentByShortId(commentShortId: $commentShortId) {
      __typename
      replies {
        totalCount
        nodes {
          ...AssetDiscussionCommentReplyFields
        }
        pageInfo {
          hasNextPage
          cursor
        }
      }
      ...AssetDiscussionCommentFields
    }
  }

  ${AssetDiscussionCommentFields}
  ${AssetDiscussionCommentReplyFields}
`;
